import { bindLinks, initApp, requestIdleCallbackFunction, unbindLinks } from './load-functions';

export enum Environment {
  Production = 'production',
  Staging = 'staging',
  Integration = 'integration',
  Local = 'local',
}

type EnvSpecificConfig<T> = {
  [key in Environment]: T;
};

const ENVIRONMENT_CDN_BASE_PATH: EnvSpecificConfig<string> = {
  local: '/',
  integration: 'https://staging-portal.noveske.com/',
  staging: 'https://staging-portal.noveske.com/',
  production: 'https://portal.noveske.com/',
};

const getBasePath = (env: string = Environment.Production): string => {
  return ENVIRONMENT_CDN_BASE_PATH[env as Environment] ?? ENVIRONMENT_CDN_BASE_PATH[Environment.Production];
};

window.b2b = {
  ...window.b2b,
  __get_asset_location: (filename) => {
    // Use portal_cdn_environment for CDN path resolution (staging vs production portal domain).
    // This is separate from "environment" which controls which BigCommerce B2B API to hit.
    const cdnEnv = window.B3?.setting?.portal_cdn_environment ?? window.B3?.setting?.environment;
    const basePath = getBasePath(cdnEnv);

    return `${basePath}${filename}`;
  },
};

(async function bootstrap() {
  // check if the accessed url contains a hashtag
  if (window.location.hash.startsWith('#/')) {
    initApp();
  } else {
    // load the app when the browser is free
    requestIdleCallbackFunction(initApp);
    // and bind links to load the app
    bindLinks();
    window.addEventListener('beforeunload', unbindLinks);
    // and observe global flag to simulate click
    window.b2b.initializationEnvironment.isInitListener = () => {
      unbindLinks();
      setTimeout(() => window.b2b.initializationEnvironment.clickedLinkElement?.click(), 0);
    };
  }
})();
